import { useCallback } from 'react';

import { FlatImageEditorProps } from '~/components/Common/Images/types';

import { getUploadedImageId, uploadImage } from '~/services/ImageService';

export default function useAccommodationImageUploadFile(imageCount: number) {
  return useCallback<NonNullable<FlatImageEditorProps['onUploadFile']>>(
    async ({ description, desiredOrder, file, filename }) => {
      const response = await uploadImage(file);
      const imageId = getUploadedImageId(response);

      if (!imageId) {
        throw new Error('Image upload did not return an image ID');
      }

      return {
        id: imageId,
        publicImageId: imageId,
        displayId: imageId,
        order: desiredOrder ?? imageCount + 1,
        description,
        filename,
      };
    },
    [imageCount],
  );
}
